import { render } from "./CatalogAdmin.vue?vue&type=template&id=0fd9373c&scoped=true"
import script from "./CatalogAdmin.vue?vue&type=script&lang=js"
export * from "./CatalogAdmin.vue?vue&type=script&lang=js"

import "./CatalogAdmin.vue?vue&type=style&index=0&id=0fd9373c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd9373c"]])

export default __exports__